<template>
<div>
	<v-combobox
		:class="dense ? 'grv-input-dense' : 'grv-input'"
		class="chiped-input"
		:menu-props="{contentClass: 'grv-menu'}"
		:rules="rules"
		dense
		ref="asset_id_input"
		@update:error="errored = $event"
		:value="value"
		clearable
		chips
		:loading="loading"
		:small-chips="dense"
		:name="param.name"
		:search-input.sync="search"
		:deletable-chips="!readonly"
		:items="items"
		:multiple="multiple"
		:readonly="readonly"
		append-icon="search"
		@click:append="showTitleAssetFinder(param)"
		@change="$emit('update:value', $event)">

		<template v-slot:label>
			<Label :param="param"></Label>
		</template>

		<template v-slot:selection="{ item }">
			<AssetChip
				:asset_id="item"
				:asset="assets[item]"
				@remove="remove(item)">
			</AssetChip>
		</template>

		<template v-slot:item="{ tile, item }">
			<v-list-tile-avatar>
				<v-icon v-if="tile.props.value" color="primary">check_box</v-icon>
				<v-icon v-else>check_box_outline_blank</v-icon>
			</v-list-tile-avatar>
			<v-list-tile-content>
				<v-list-tile-title>
					{{ item }}
				</v-list-tile-title>
				<v-list-tile-sub-title class="font-italic caption">
					{{ getAssetTitle(item) }}
				</v-list-tile-sub-title>
			</v-list-tile-content>
		</template>

		<template v-slot:no-data>
			<v-list-tile>
				<v-list-tile-content>
					<v-list-tile-title>
						Saisissez un asset ID
						<span v-if="search">
							"<strong>{{ search }}</strong>"
						</span>.
						Appuyez sur <kbd>Entrée</kbd> pour l'ajouter
					</v-list-tile-title>
				</v-list-tile-content>
			</v-list-tile>
		</template>
	</v-combobox>

	<Hint :param="param" :errored="errored"></Hint>

	<TitleAssetFinder
		v-if="titleAssetFinder.visible"
		:multiselect="multiple"
		:toolbarTitle="titleAssetFinder.destination_key"
		:return_objects="true"
		:babel_id="babel_id"
		:behive_category="behive_category"
		@close="titleAssetFinder.visible = false;
						titleAssetFinder.destination_key = null"
		@selectedAssets="onAssetIdsSelected($event);
										titleAssetFinder.destination_key = null">
		<h3 slot="header">Asset Select</h3>
	</TitleAssetFinder>
</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
import TitleAssetFinder from '@/components/modal_title_asset_finder.vue'
import AssetChip from '@/components/asset_chip.vue'
const assetRE = /^(maestro|suifa)-\d+$/
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense',
		'babel_id',
		'babel_label',
		'loading',
		'behive_category'
	],
	components: {
		TitleAssetFinder,
		Label,
		Hint,
		AssetChip
	},
	data () {
		return {
			rules: [],
			errored: false,
			search: null,
			titleAssetFinder: {
				visible: false,
				destination_key: null
			},
			assets: {}
		}
	},
	computed: {
		multiple () {
			return this.param.type.indexOf('multi-assetid') === 0
		},
		items () {
			if (this.multiple) return this.value
			return []
		}
	},
	watch: {
		async value (val) {
			this.init(val)
		}
	},
	methods: {
		async init (value) {
			if (this.multiple) {
				for (const assetId of value) {
					if (assetRE.test(assetId)) {
						await this.getAssetData(assetId)
					} else {
						this.$set(this.assets, assetId, { not_found: true })
					}
				}
				for (const key in this.assets) {
					if (value.indexOf(key) === -1) delete this.assets[key]
				}
			} else {
				if (assetRE.test(value)) {
					await this.getAssetData(value)
				} else {
					this.$set(this.assets, value, { not_found: true })
				}
				for (const key in this.assets) {
					if (value !== key) delete this.assets[key]
				}
			}
			this.$refs.asset_id_input.blur()
		},
		showTitleAssetFinder (param) {
			this.titleAssetFinder.destination_key = this.param.name
			this.titleAssetFinder.visible = true
		},
		remove (asset_id) {
			if (this.multiple) {
				this.$emit(
					'update:value',
					this.value.filter(assetID => assetID !== asset_id)
				)
			} else {
				this.$emit('update:value', '')
			}
		},
		getAssetTitle (asset_id) {
			let typeSup = this.$commons.deepGet(
				this.assets,
				[asset_id, 'type_sup', 'lib_type_sup'],
				'-'
			)
			let title = this.$commons.deepGet(
				this.assets,
				[asset_id, 'title', 'name'],
				'-'
			)
			return `${typeSup} | ${title}`
		},
		onAssetIdsSelected (evt) {
			let ids = evt.map(asset => asset.id)
			for (const asset of evt) {
				this.$set(this.assets, asset.id, asset)
			}
			if (this.multiple) {
				this.$emit('update:value', ids)
			} else {
				this.$emit('update:value', ids[0])
			}
		},
		getAssetData (asset_id) {
			this.$EsMaestro.asset_get(asset_id)
				.then(result => {
					if (result) {
						this.$set(this.assets, asset_id, result)
					} else {
						this.$set(this.assets, asset_id, { not_found: true })
					}
				})
				.catch(error => {
					console.log(error)
					this.$set(this.assets, asset_id, { not_found: true })
				})
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			if (Array.isArray(value) && value.length === 0) return 'Requis'
			return true
		},
		assetidCheck (value) {
			if (!value) return true
			return assetRE.test(value) || 'Mauvais asset id'
		},
		multiAssetidCheck (value) {
			if (!value) return true
			if (!Array.isArray(value)) value = value.split(',')
			for (const assetId of value) {
				if (!assetRE.test(assetId.trim())) {
					return 'Mauvais asset id'
				}
			}
			return true
		}
	},
	mounted () {
		this.init(this.value)
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.param.type.indexOf('assetid') === 0) {
			this.rules.push(this.assetidCheck)
		} else if (this.param.type.indexOf('multi-assetid') === 0) {
			this.rules.push(this.multiAssetidCheck)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/assetid.vue